import CourtMartialChargeCollection from './CourtMartialChargeCollection';

export default CourtMartialChargeCollection;
